export enum FieldValidationType {
  EMAIL = 'Email',
  ZIP = 'Zip',
  PHONE = 'Phone',
  JSON = 'JSON',
  CASE_NUMBER = 'Case Number',
}

export enum CharacterType {
  NUMERIC = 'numbers',
  ALPHABETS = 'letters',
  ALPHANUMERIC = 'letters & numbers',
  ALPHANUMERIC_WITH_SPACES = 'letters, spaces & numbers',
  ALPHA_WITH_SPACES = 'alphabets with spaces',
  INTEGERS = 'integers',
}

export default class ErrorMessageGenerator {
  public getMandatoryFieldMessage(fieldName: string) {
    return `${fieldName} is required`;
  }

  public getCharacterLimitMessage(fieldName: string, characterLimit: number) {
    return `${characterLimit} character limit.`;
  }

  public getMinMaxCharacterLimitMessage(fieldName: string, minLimit: number, maxLimit: number) {
    return `Min ${minLimit} and Max ${maxLimit} characters limit.`;
  }

  public getLeastCharacterMessage(fieldName: string, atleastCharacter: number) {
    return `At least ${atleastCharacter} characters.`;
  }

  public getInvalidFieldMessage(fieldName: string, fieldType: FieldValidationType) {
    return `${fieldType} format is invalid.`;
  }

  public getLimitedCharacterTypeMessage(fieldName: string, characterType: CharacterType) {
    return `Only ${characterType} allowed.`;
  }

  public getPicklistEmptyMessage(fieldName: string) {
    return 'Picklist type should have options';
  }

  public getInvalidNumberRangeMessage(lowerLimit: number, upperLimit: number) {
    return `Please choose number between ${lowerLimit} and ${upperLimit}`;
  }

  public getInvalidPasswordMessage() {
    return 'Enter valid password';
  }

  public getPasswordMismatchMessage() {
    return 'Passwords do no match';
  }

  public getDeleteAllCapsMessage() {
    return 'Please enter DELETE in all caps';
  }

  public getFileNameCharacterLimitMessage(maxCharLimit: number) {
    return `File name exceeds ${maxCharLimit} character limit`;
  }

  public getUnsupportedFileFormatMessage() {
    return 'One/more files with unsupported format is/are discarded.';
  }

  public getMaxFileSizeLimitMessage(maxFileSizeInMB: number) {
    return `File size cannot exceed ${maxFileSizeInMB}MB`;
  }

  public getOptionalFieldNamesMessage(fields: string[]) {
    return `${fields.join(' or ')} is required`;
  }

  public getMinDaysLimitMessage(minLimit: number) {
    return `Min ${minLimit} days limit.`;
  }

  public getMinMaxDaysLimitMessage(minLimit: number, maxLimit: number) {
    return `Min ${minLimit} and Max ${maxLimit} days limit.`;
  }
}
